import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import { useDeliverForm } from './useDeliverForm.jsx';
import CardTabs from '../../../../shared/CardTabs';

const Container = styled.div`
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 0px 8px 8px 8px;
  height: 1001px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
`;

const Iframe = styled.iframe`
  height: 100%;
  padding: 24px 16px;
`;

const Subject = styled.h2`
  margin: 0;
  color: ${themeGet('colors.black.100')};
  font-size: 14px;
  font-weight: 500;
  overflow-wrap: anywhere;
`;

export default function TilePreview() {
  const {
    iframeSrc,
    iframeRef,
    iframe,
    setIframe,
    updateIframe,
    values,
  } = useDeliverForm();
  const { t } = useTranslation('send');

  const tabs = [
    {
      name: 'tileDigest',
      content: t('deliver.tileDigestTitle'),
    },
    {
      name: 'followUp',
      content: t('deliver.followUpTitle'),
    },
    {
      name: 'sms',
      content: t('deliver.smsTitle'),
    },
  ];

  return (
    <div style={{ height: '100%' }}>
      <div>
        <CardTabs tabs={tabs} activeTab={iframe} setActiveTab={setIframe} />
      </div>
      <Container>
        {iframe !== 'sms' && (
          <Subject>
            {t('deliver.subjectPreview', {
              subject: values.customSubject || t('deliver.emptySubjectDefault'),
            })}
          </Subject>
        )}
        <Iframe
          id="share_tiles_digest_preview"
          src={iframeSrc}
          width="100%"
          height="100%"
          ref={iframeRef}
          onLoad={updateIframe}
        />
      </Container>
    </div>
  );
}
